// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_gd-0";